module.exports = __webpack_public_path__ + "static/media/logoorange.9f6f87ae.png";